<template>
  <v-container fill-height container--fluid >
      <v-row  style="margin-top:20px;">      
        <v-col cols="12" sm="12" md="12" lg="12">
          <v-row justify="end" align="right">
            <v-col cols="12" sm="12" md="3" lg="3" align="right">
              <v-autocomplete
                v-model="billingSelectedFilter"
                :items="billingFilterItems"
                item-value="id" 
                item-text="name"
                solo
                dense                                    
                label="Billing Names"
                @change="search()"            
              ></v-autocomplete>                
            </v-col>
            <v-col cols="12" sm="12" md="3" lg="3" align="right">
              <v-autocomplete
                v-model="campaignSelectedFilter"
                :items="campaignFilterItems"
                item-value="id" 
                item-text="name"
                solo
                dense                                    
                label="Campaign Names"
                @change="search()"            
              ></v-autocomplete>                
            </v-col>
            <v-col cols="12" sm="12" md="1" lg="1" style="margin-top:5px;" align="left">
              <v-btn small color="secondary" @click="clearFilter">Clear</v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
          <v-col cols="12" sm="12">
            <v-data-table
              :headers="campaignReportHeaders"
              :items="campaignReportData"
              single-expand
              :expanded.sync="expanded"                   
              item-key="id"                                  
              class="elevation-1"                     
              show-expand
            >
              <template v-slot:[`item.clientName`]="{ item }">
                <v-icon v-if="item.campaignGroup">mdi-domain</v-icon> {{item.clientName}}
              </template>
              <template v-slot:[`item.IOAmount`]="{ item }">
                <span v-if="item.IOAmount === 0">N/A</span>
                <v-chip class="ma-1" color="primary" small text-color="white" v-else>
                  <v-icon small left class="mr-0">mdi-currency-usd</v-icon>
                  <span>{{ item.IOAmount | thousandSeprator}}</span>
                </v-chip>
              </template>
              <template v-slot:[`item.cogs`]="{ item }">
                <v-icon small class="currency">mdi-currency-usd</v-icon>{{ item.cogs | thousandSeprator}}
              </template>
              <template v-slot:[`item.revenue`]="{ item }">
                <v-chip class="ma-1" color="green" small text-color="white">
                  <v-icon small left class="mr-0">mdi-currency-usd</v-icon>
                  <span>{{ item.revenue | thousandSeprator}}</span>
                </v-chip>
              </template>

              <template v-slot:[`item.avgInfluencerRatings`]="{item}">
                <div class="text-center">                    
                  <v-rating 
                    v-model="item.avgInfluencerRatings"
                    class="v-rating-button"
                    readonly
                    dense
                    small
                    length="5"                                                                      
                    >
                  </v-rating>
                </div>
              </template>

              <template v-slot:[`item.avgClientRatings`]="{item}">
                <div class="text-center">                    
                  <v-rating 
                    v-model="item.avgClientRatings"
                    class="v-rating-button"
                    readonly
                    dense
                    small
                    length="5"                                                                      
                    >
                  </v-rating>
                </div>
              </template>

              <!-- <template v-slot:[`item.vertical`]="{item}">
                  <v-chip
                      class="ma-1"
                      small
                      v-for="(item, index) in item.vertical"
                      :key="index"
                  >
                      {{ item.name }}
                  </v-chip>
              </template> -->
              <template v-slot:[`item.amountPaid`]="{ item }">
                <v-icon small class="currency">mdi-currency-usd</v-icon>{{ item.amountPaid | thousandSeprator}}
              </template>
              <template v-slot:expanded-item="{ headers, item }" style="box-shadow:none;">
                <td :colspan="headers.length" style="border:none;padding:20px;" v-if="item.influencers">
                  <v-data-table
                    :headers="detailsHeaders"
                    :items="item.influencers"
                    class="payout-table-small elevation-1"
                    hide-default-footer                       
                  >
                    <template v-slot:[`item.handle`]="{ item }">
                      <a
                        target="_blank"
                        v-bind:href="'https://instagram.com/' + item.handle"
                      >@{{ item.handle }}</a>
                    </template>
                    <template v-slot:[`item.amount`]="{ item }">
                      <v-icon small class="currency">mdi-currency-usd</v-icon>{{ item.amount | thousandSeprator}}
                    </template>
                    <template v-slot:[`item.influencerRating`]="{item}">
                      <div class="text-center">                    
                        <v-rating 
                          v-model="item.influencerRating"
                          class="v-rating-button"
                          readonly
                          dense
                          small
                          length="5"                                                                      
                          >
                        </v-rating>
                      </div>
                    </template>                                     
                  </v-data-table>
                </td>

                <td :colspan="headers.length" style="border:none;padding:20px;" v-else>
                  <v-data-table
                    :headers="campaignReportHeaders"
                    :items="item.campaigns"
                    class="elevation-1"
                    single-expand
                    :expanded.sync="expanded2"                   
                    :key="dataTableKey"         
                    show-expand                              
                  >  
                    <template v-slot:[`item.IOAmount`]="{ item }">
                      <span v-if="item.IOAmount === 0">N/A</span>
                      <v-chip class="ma-1" color="primary" small text-color="white" v-else>
                        <v-icon small left class="mr-0">mdi-currency-usd</v-icon>
                        <span>{{ item.IOAmount | thousandSeprator}}</span>
                      </v-chip>
                    </template>
                    <template v-slot:[`item.cogs`]="{ item }">
                      <v-icon small class="currency">mdi-currency-usd</v-icon>{{ item.cogs | thousandSeprator}}
                    </template>
                    <template v-slot:[`item.revenue`]="{ item }">
                      <v-chip class="ma-1" color="green" small text-color="white">
                        <v-icon small left class="mr-0">mdi-currency-usd</v-icon>
                        <span>{{ item.revenue | thousandSeprator}}</span>
                      </v-chip>
                    </template>

                    <template v-slot:[`item.avgInfluencerRatings`]="{item}">
                      <div class="text-center">                    
                        <v-rating 
                          v-model="item.avgInfluencerRatings"
                          class="v-rating-button"
                          readonly
                          dense
                          small
                          length="5"                                                                      
                          >
                        </v-rating>
                      </div>
                    </template>

                    <template v-slot:[`item.avgClientRatings`]="{item}">
                      <div class="text-center">                    
                        <v-rating 
                          v-model="item.avgClientRatings"
                          class="v-rating-button"
                          readonly
                          dense
                          small
                          length="5"                                                                      
                          >
                        </v-rating>
                      </div>
                    </template>

                    <template v-slot:[`item.vertical`]="{item}">
                        <v-chip
                            class="ma-1"
                            small
                            v-for="(item, index) in item.vertical"
                            :key="index"
                        >
                            {{ item.name }}
                        </v-chip>
                    </template>
                    <template v-slot:[`item.amountPaid`]="{ item }">
                      <v-icon small class="currency">mdi-currency-usd</v-icon>{{ item.amountPaid | thousandSeprator}}
                    </template>
                    <template v-slot:expanded-item="{ headers, item }" style="box-shadow:none;">
                      <td :colspan="headers.length" style="border:none;padding:20px;">
                        <v-data-table
                            :headers="detailsHeaders"
                            :items="item.influencers"
                            class="payout-table-small elevation-1"
                            hide-default-footer                       
                        >
                          <template v-slot:[`item.handle`]="{ item }">
                            <a
                              target="_blank"
                              v-bind:href="'https://instagram.com/' + item.handle"
                            >@{{ item.handle }}</a>
                          </template>
                          <template v-slot:[`item.amount`]="{ item }">
                            <v-icon small class="currency">mdi-currency-usd</v-icon>{{ item.amount | thousandSeprator}}
                          </template>
                          <template v-slot:[`item.influencerRating`]="{item}">
                            <div class="text-center">                    
                              <v-rating 
                                v-model="item.influencerRating"
                                class="v-rating-button"
                                readonly
                                dense
                                small
                                length="5"                                                                      
                                >
                              </v-rating>
                            </div>
                          </template>                                     
                        </v-data-table>
                      </td>
                    </template>
                  </v-data-table>
                </td>
              </template>

            </v-data-table>
          </v-col>          
      </v-row>
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
        loader="bars"
        background-color="#000"
        color="secondary"
        width.number="180"
        height.number="180"
      />
  </v-container>
</template>
<script>
import { mapState } from 'vuex';
import campaignAPIs from '../Campaign/campaignAPIs';
import clientAPIs from '../Client/clientAPIs';
import Loading from 'vue-loading-overlay';
// Components
export default {
  name: 'payouts-report',
  components: {
    Loading
  },
  data() {
    return {
      campaignReportHeaders: [
        {
          'text': 'Client Name',
          'align': 'start',
          'value': 'clientName',
          'sortable': true
        },
        {
          'text': 'Campaign Name',
          'align': 'center',
          'sortable': true,
          'value': 'name'
        },
        {
          'text': 'IO Number',
          'align': 'center',
          'sortable': true,
          'value': 'ioNumbers'
        },
        {
          'text': 'Vertical',
          'align': 'center',
          'sortable': true,
          'value': 'vertical'
        },
        {
          'text': 'Total IO Budget',
          'align': 'center',
          'sortable': true,
          'value': 'IOAmount'
        },
        {
          'text': 'COGS Amount',
          'align': 'center',
          'sortable': true,
          'value': 'cogs'
        },
        {
          'text': 'Revenue Recognize',
          'align': 'center',
          'sortable': true,
          'value': 'revenue'
        },
        {
          'text': 'NPS',
          'align': 'center',
          'sortable': true,
          'value': 'nps'
        },
        {
          'text': 'Average Influencer Ratings',
          'align': 'center',
          'sortable': true,
          'value': 'avgInfluencerRatings'
        },
        {
          'text': 'Average Client Ratings',
          'align': 'center',
          'sortable': true,
          'value': 'avgClientRatings'
        },
        {
          'text': 'Amount Paid to Creators',
          'align': 'center',
          'sortable': true,
          'value': 'amountPaid'
        }
      ],
      detailsHeaders: [
        {
          'text': 'Handle',
          'align': 'start',
          'value': 'handle',
          'sortable': true
        },
        {
          'text': 'Following',
          'align': 'start',
          'value': 'following',
          'sortable': true
        },
        {
          'text': 'Engagement Rate',
          'align': 'start',
          'value': 'engagementRate',
          'sortable': true
        },
        {
          'text': 'Status',
          'align': 'start',
          'value': 'status',
          'sortable': true
        },
        {
          'text': 'Amount',
          'align': 'start',
          'value': 'amount',
          'sortable': true
        },
        {
          'text': 'Live Date',
          'align': 'start',
          'value': 'liveDate',
          'sortable': true
        },
        {
          'text': 'Payment Date',
          'align': 'start',
          'value': 'paymentDate',
          'sortable': true
        },
        {
          'text': 'Payee Name',
          'align': 'start',
          'value': 'payeeName',
          'sortable': true
        },
        {
          'text': 'Bank A/C No.',
          'align': 'start',
          'value': 'bankACNo',
          'sortable': true
        },
        {
          'text': 'Swift Code',
          'align': 'start',
          'value': 'swiftCode',
          'sortable': true
        },
        {
          'text': 'BIB REF',
          'align': 'start',
          'value': 'BIBRef',
          'sortable': true
        },
        {
          'text': 'FT REF',
          'align': 'start',
          'value': 'FTRef',
          'sortable': true
        },
        {
          'text': 'Deliverable',
          'align': 'start',
          'value': 'deliverable',
          'sortable': true
        },
        {
          'text': 'Rating from Influencer',
          'align': 'start',
          'value': 'influencerRating',
          'sortable': true
        },
        {
          'text': 'Date paid to influencer',
          'align': 'start',
          'value': 'paidDate',
          'sortable': true
        },
        {
          'text': 'Source',
          'align': 'start',
          'value': 'source',
          'sortable': true
        }
      ],
      campaignReportData: [],
      billingFilterItems: [],
      campaignFilterItems: [],
      billingSelectedFilter: '',
      campaignSelectedFilter: '',
      // pagging: {
      //   page: 1,
      //   itemsPerPage: 10,
      //   totalItems: 0
      // },
      currentFilter: {},
      isLoading: false
    }
  },
  // watch: {
  //   pagging(newValue) {
  //     this.search(newValue);
  //   }
  // },
  computed: {
    ...mapState(['user']),
    currentUserRole: function() {
      return this.user.role;
    },
    currentUserID: function() {
      return this.user.id;
    }
  },
  async mounted() {
    this.campaignReportDataObject = Object.assign(this.campaignReportData, [])
    if (this.$route.query.id) {
      this.campaignSelectedFilter = this.$route.query.id
    }
    try {
      this.search({})
      // get campaigns
      const resp = await campaignAPIs.getUnfinishedCampaigns();
      this.campaignFilterItems = resp
      this.campaignFilterItems.unshift({id: '', name: 'All Campaigns'})
      // get clients
      const clientResp = await clientAPIs.getAllClients();
      this.billingFilterItems = clientResp.data
      let clientIDs = [...new Set(this.campaignFilterItems.map(c => c.clientID))]
      this.billingFilterItems = this.billingFilterItems.filter(b => clientIDs.includes(b.id))
      this.billingFilterItems.unshift({id: '', name: 'All Clients'})
    } catch (error) {
      console.log(error);
      this.$swal({
        text: 'Cannot fetch required data!',
        icon: 'error'
      });
    }
  },
  methods: {
    async getInfluencerReport(filter) {
      try {
        this.isLoading = true;
        let result = await campaignAPIs.getCampaignsInfluencerReport(filter);
        if (result) {
          this.campaignReportData = result.groups
        }
      } catch (error) {
        console.log(error);
        this.$swal({
          text: 'Cannot fetch Influencer Report',
          icon: 'error'
        });
      } finally {
        this.isLoading = false;
      }
    },
    getColor (minusNumber) {
      if (minusNumber) {
        if (minusNumber.toString().indexOf('-') !== -1) return 'red'
      }
    },
    search(filter) {
      if (!filter) {
        filter = this.currentFilter
        // filter.page = 1
      }
      let allFilter = Object.assign(filter, {
        clientID: this.billingSelectedFilter,
        campaignID: this.campaignSelectedFilter
      });
      this.currentFilter = allFilter
      this.getInfluencerReport(allFilter)
    },
    clearFilter() {
      this.billingSelectedFilter = ''
      this.campaignSelectedFilter = ''
      this.getInfluencerReport(this.filter)
    }
  }
}
</script>
<style scoped>
.sub-title {
  font-size: 38px !important;
  font-weight: 300;
}
.currency {
  margin-top: -3px;
}

@font-face {
    font-family: WorkSans-Regular;
    src: url('/static/fonts/WorkSans-Regular.ttf');
}
@font-face {
    font-family: WorkSans-ExtraLight;
    src: url('/static/fonts/WorkSans-ExtraLight.ttf');
}
@font-face {
    font-family: WorkSans-SemiBold;
    src: url('/static/fonts/WorkSans-SemiBold.ttf');
}
@font-face {
    font-family: WorkSans-Medium;
    src: url('/static/fonts/WorkSans-Medium.ttf');
}
</style>
<style>
.payout-table-small thead th.text-start {
  padding: 0!important;
  text-align: center!important;
  padding-left: 1px!important;
}

.payout-table-small tbody td.text-start,
.payout-table-small tbody td.text-xs-left,
.payout-table-small tbody td.text-center {
  font-size: 12px!important;
  padding: 0!important;
  text-align: center!important;
}
</style>



// WEBPACK FOOTER //
// payoutsReport.vue?7621ef29